import { render, staticRenderFns } from "./VwResizePreview.vue?vue&type=template&id=6d3e20f6&scoped=true&lang=pug&"
import script from "./VwResizePreview.vue?vue&type=script&lang=ts&"
export * from "./VwResizePreview.vue?vue&type=script&lang=ts&"
import style0 from "./VwResizePreview.vue?vue&type=style&index=0&id=6d3e20f6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3e20f6",
  null
  
)

component.options.__file = "VwResizePreview.vue"
export default component.exports